import { useEffect, useRef } from "react";

interface ResumePromptDialogProps {
  open: boolean;
  onResume: () => void;
  onDiscard: () => void;
}

/**
 * Native <dialog> that asks the user whether to resume a previous
 * Schrijven session found in localStorage.
 */
export function ResumePromptDialog({
  open,
  onResume,
  onDiscard,
}: ResumePromptDialogProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    else if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="rounded-xl border border-[var(--border)] bg-[var(--panel)] p-6 space-y-4 max-w-sm w-full shadow-[var(--shadow)] backdrop:bg-black/60"
      onCancel={(e) => {
        e.preventDefault();
        onDiscard();
      }}
    >
      <h2 className="text-lg font-semibold tracking-tight text-[var(--ink)]">
        Doorgaan?
      </h2>
      <p className="text-sm text-[var(--ink-muted)] leading-relaxed">
        U heeft een onvoltooide oefening. Wilt u verdergaan waar u gebleven
        was, of opnieuw beginnen?
      </p>
      <div className="flex gap-3 justify-end pt-2">
        <button
          type="button"
          onClick={onDiscard}
          className="inline-flex h-10 items-center justify-center rounded-[var(--radius)] border border-[var(--border)] bg-transparent px-4 text-sm text-[var(--ink-muted)] hover:bg-[var(--panel-soft)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2 transition-colors"
        >
          Opnieuw beginnen
        </button>
        <button
          type="button"
          onClick={onResume}
          className="inline-flex h-10 items-center justify-center rounded-[var(--radius)] bg-[var(--accent)] px-4 text-sm font-medium text-white hover:bg-[var(--accent-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2 transition-colors"
        >
          Verdergaan
        </button>
      </div>
    </dialog>
  );
}
